import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupInviteAcceptPage } from "@/features/study-group-invite/components/StudyGroupInviteAcceptPage";

export const Route = createFileRoute("/study-group-invite-accept/$token")({
  component: StudyGroupInviteAcceptPage,
});
